import { useAuth } from '@/utils/AuthContext';

// Artifact types blocked for basic tier — none: Basic now includes all tools
const BASIC_BLOCKED_ARTIFACTS: string[] = [];

export function useAiPagePermissions(
  itemCount: number,
  freeLimit: number,
  artifactType?: string,
) {
  const { subscriptionTier } = useAuth();
  const isFree = subscriptionTier === 'free';
  const isBasic = subscriptionTier === 'basic';

  // Basic tier blocks financial model and marketing strategy
  const isBlockedForBasic = isBasic && artifactType
    ? BASIC_BLOCKED_ARTIFACTS.includes(artifactType)
    : false;

  const canCreateNew = (!isFree && !isBlockedForBasic) || itemCount < freeLimit;
  const canEdit = !isFree && !isBlockedForBasic;
  const canDelete = !isFree;
  return { isFree, isBasic, isBlockedForBasic, canCreateNew, canEdit, canDelete, subscriptionTier };
}
